import { useDispatch, useSelector } from "react-redux"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { cartolaBuildingState, changeStatus, onFetchCartolaBuildings, onSetTotalRows } from "../redux/slices/cartolaBuildingSlice"
import { ApiStatus } from "../types/api/status"
import { CartolaBuildingAPI } from "../apis/CartolaBuildingAPI"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"

export const useCartolaBuildingStore = () => {
    const dispatch = useDispatch()
    const { cartolaBuildings, selectedCartolaBuilding, status, totalRows } = useSelector(cartolaBuildingState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.data?.idcompany

    const getCartolaBuilding = async (data?: object) => {
        dispatch(dispatch(changeStatus(ApiStatus.FETCHING)))
        try {
            const response = await CartolaBuildingAPI.get(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || '')

                return false;
            }

            const { detail, total } = response.data

            dispatch(onFetchCartolaBuildings(detail || []))
            dispatch(onSetTotalRows(total || 0))

            return true
        } catch (error) {
            dispatch(changeStatus(ApiStatus.FETCHED))
            console.error(error)

            return false
        }
    }

    const generatePDF = async (idbuilding: number, start_date: string, end_date: string) => {
        try {
            const response = await CartolaBuildingAPI.generatePDF(idbuilding, start_date, end_date, idcompany)
            if (!response?.status) {
                CustomSnackbar('error', response.data.message)

                return false
            }

            return response.data
        } catch (error) {
            console.log(error)

            return false
        }
    }

    return {
        cartolaBuildings,
        selectedCartolaBuilding,
        status,
        totalRows,
        getCartolaBuilding,
        generatePDF
    }
}